<template>
  <div class="modal fade modal-payin in" tabindex="-1" role="dialog" style="display: block;" v-if="action">
    <div class="modal-dialog modal-sm" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Kapat" @click="action = false">
            <span aria-hidden="true">×</span>
          </button>
          <h4 class="modal-title" v-text="operate === '+' ? t.custom_reseller_panel.balance_in : t.custom_reseller_panel.balance_out"></h4>
        </div>
        <div class="modal-body">
          <div id="payin-loading" v-if="loading">
            <Loading></Loading>
          </div>
          <div id="payin-form" v-else>
            <div class="form-group">
              <label>{{ t.amount }}</label>
              <input type="number" step="0.01" name="amount" id="amount" class="form-control"
                     placeholder="Atım yapmak istediğiniz tutar" v-model="amount"
                     pattern="(0\.((0[1-9]{1})|([1-9]{1}([0-9]{1})?)))|(([1-9]+[0-9]*)(\.([0-9]{1,2}))?)">
            </div>
            <div class="form-group">
              <select class="form-control" v-model="reason">
                <option :value="0">{{ t.select }}</option>
                <option v-for="r in reasons" :value="r.id">{{ r.name }} </option>
              </select>
            </div>
            <div class="form-group" v-if="reason > 0">
              <button class="btn btn-block btn-success" @click="payin">{{ t.p2p_money_transfer.transfer }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "./Loading";
export default {
  name: "PayinModal",
  components: {Loading},
  mounted() {
    this.$bus.$on('payinModal', (payload) => {
      this.userId = payload.id;
      this.action = payload.action;
      this.operate = payload.operate
    })

    this.fetchReasons();
  },
  data() {
    return {
      api: window.api,
      t: this.$root.t,
      session: this.$root.session,
      transactionType: 1,
      transferType: 1,
      operate: '+',
      amount: 0,
      response: null,
      expiryDate: moment().add(5, 'days'),
      errors: null,
      userId: 0,
      note: '',
      action: false,
      loading: false,
      reason: 0,
      reasons: []
    }
  },
  methods: {
    fetchReasons() {
      this.$http.get(bsapi + 'api/v1/transactions/reasons').then( response => {
            this.reasons = response.body.result;
      })
    },
    payin() {
      this.loading = true;
      this.$http.post(api + 'api/v1/user/transaction/money_transfer',
  {
          note: this.note,
          mode: this.transactionType,
          type: 1,
          amount: this.amount,
          operate: this.operate,
          to: this.userId,
          from: 0,
          reason: this.reason,
          expiryDate: moment(this.expiryDate).utc().format("YYYY-MM-DD HH:mm:ss")
        }).then(response => {
        this.response = response.body.result;
        this.errors = response.body.error;
        this.loading = false;
        this.$fire({
          title: this.t.processing.success,
          text: response.body.result.SUCCESS,
          type: "success",
          timer: 3000
        }).then(r => {
          this.action = false;
        });
      }, response => {
        this.errors = response.body.error;
        this.loading = false;
        this.$fire({
          title: "Oppps!",
          text: Object.values(response.body.error)[0],
          type: "error",
          timer: 3000
        }).then(r => {
        });
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PayinModal.vue